export default {
    not_empty:[v => /^.+$/.test(v) || 'Field ini tidak boleh kosong'],
    boolean:[v=>/^[0|1]$/.test(v)|| 'Input Tidak Valid'],
    email: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail tidak valid'
    ],
    nama: [
        v => /^.+$/.test(v) || 'Nama tidak boleh kosong',
        v => /^[a-zA-Z\s]{3,50}$/.test(v) || 'Nama tidak valid'
    ],
    code: [
        v => !!v || 'Code is required',
    ],
    nama_w_number: [
        v => /^.+$/.test(v) || 'Nama tidak boleh kosong',
        v => /^[a-zA-Z0-9\s]{3,50}$/.test(v) || 'Nama tidak valid'
    ],
    codeLocale: [
        v => /^.+$/.test(v) || 'Code tidak boleh kosong',
        v => /^[a-zA-Z\s]{1,2}$/.test(v) || 'Code tidak valid',
    ],
    password: [
        v => /^.+$/.test(v) || 'Password tidak boleh kosong',
    ],
    new_password:[
        true
    ]
}